import Merchants from "./merchants.js";

const listTransactions = (props) => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexApiPayment,
  ];

  if (nonDefaultClientRequires.some((plugin) => plugin === true)) {
    return Merchants[merchant].ListTransactions(props);
  }
};

export default listTransactions;
